import ShippingFields, { createValidationRules as vf } from './shipping-fields'

export const createValidationRules = vf
export default ShippingFields
